export * from './actividad';
export * from './actividad-filter';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/actividad/index.ts